import { render } from "./StateManagementDashboard.vue?vue&type=template&id=b65bcd52&scoped=true"
import script from "./StateManagementDashboard.vue?vue&type=script&lang=js"
export * from "./StateManagementDashboard.vue?vue&type=script&lang=js"

import "./StateManagementDashboard.vue?vue&type=style&index=0&id=b65bcd52&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b65bcd52"]])

export default __exports__